import { validationEngine, validationInfo as vi } from "utils/simple-validations";
import { rulesEngine, dirtyInfo as di } from "utils/rules-engine";
import curry from "lodash.curry";

export function create(document) {
  return {
    document,
    dirtyInfo: di.create(),
    validationInfo: vi.create()
  };
}

export const update = curry(function (prop, value, businessRules, editableDocument) {
  const { document, dirtyInfo } = rulesEngine.update(
    editableDocument.document,
    businessRules,
    { [prop]: value },
    editableDocument.dirtyInfo
  );
  if (dirtyInfo.isDirty) {
    return {
      ...editableDocument,
      document,
      dirtyInfo: di.merge(dirtyInfo, editableDocument.dirtyInfo)
    };
  }
  return editableDocument;
});

export const validate = curry(function (validationRules, dirtyFieldsOnly, editableDocument) {
  const filterFunc = dirtyFieldsOnly ? field => di.isPropertyDirty(field, editableDocument.dirtyInfo) : null;

  const validationInfo = validationEngine.validate(editableDocument.document, validationRules, filterFunc);
  return {
    ...editableDocument,
    validationInfo: vi.merge(validationInfo, editableDocument.validationInfo)
  };
});

export function resetDirtyInfo(editableDocument) {
  return {
    ...editableDocument,
    dirtyInfo: di.create()
  };
}

export function resetValidationInfo(editableDocument) {
  return {
    ...editableDocument,
    validationInfo: vi.create()
  };
}

export function setDirty(editableDocument) {
  return {
    ...editableDocument,
    dirtyInfo: di.create(true)
  };
}
